import { AttrJsonEditContext } from '../html-attribute';

/**
 * information about the current item
 * ATM empty, not sure if it serves a purpose...
 * @internal
 */
export class ContextOfItem {
    // tslint:disable-next-line: no-empty
    constructor(editCtx: AttrJsonEditContext) {}
}
